<template>

  <div>
    <v-text-field v-model="assetType.name" :label="$tc('asset-types.entity-name', 1)"></v-text-field>

    <asset-type-autocomplete v-model="assetType.parentId" :label="$tc('asset-types.parent', 1)" />
  </div>

</template>

<script>
  import AssetTypeAutocomplete from '../asset-type-autocomplete'

  export default {
    name: 'asset-type-form',

    props: [ 'assetType' ],

    components: {
      AssetTypeAutocomplete
    }
  }
</script>

<style scoped lang="scss">

</style>
